import { ApolloError } from "@apollo/client";
import { useUserOrganizations } from "@/hooks/useUserOrganizations";
import { useParams } from "react-router-dom";
import { Organization } from "@/types/Organization";

export const useOrg = (): {
  org: Organization | undefined;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const { orgId } = useParams<{ orgId: string | undefined }>();
  const { data: groupOrgsData, loading, error } = useUserOrganizations();

  if (loading || !groupOrgsData) return { org: undefined, loading, error };

  const org = groupOrgsData?.find((org) => org.id === orgId);

  return {
    org,
    loading: loading,
    error: error,
  };
};
